<!--
组件名：列表表单展示组件【全局组件】
描述： 同上
作者：林伟鑫
创建时间：2023-09-27 14:00
更新时间：2023-10-08 14:32

使用方法：
<s-list-form :formListData="表单数据源" :formFieldData="字段表数据源" @changeForm="事件函数" @select="勾选函数"></s-list-form>

插槽：
actionBtn 按钮插槽 
插槽使用示例：
<template v-slot:actionBtn="slotProps">
  <u-button type="primary" @click="changeForm(slotProps.formItem)">测试</u-button>
</template>
-->
<template>
	<view class="list-form">
		<!-- 字段数据源 -->
		<view v-for="(formFieldItem, index) in formFieldData" :key="index">
			<!-- 标题 -->
			<view v-if="formFieldItem.headline" class="form-headline">{{formFieldItem.headline || "" }}</view>

			<!-- 表单数据源 -->
			<view v-for="(formDataItem, formDataIdx) in formListData" :key="formDataItem.id">
				<view class="form-field-list" @click.stop="clickChange(formDataItem)">
					<!-- 勾选栏 -->
					<view v-if="isShowCheck">
						<u-radio-group v-if="checkType === 'radio'" :value="radioGroupValue" placement="column" @change="(value) => selectChange(formDataItem, value)">
							<u-radio :customStyle="{ marginBottom: '8px' }" :name="formDataItem.id">
							</u-radio>
						</u-radio-group>
						<u-checkbox-group v-if="checkType === 'checkbox'" :value="checkBoxGroupValue" placement="column" @change="(value) => selectChange(formDataItem, value)">
							<u-checkbox :customStyle="{ marginBottom: '8px' }" :name="formDataItem.id">
							</u-checkbox>
						</u-checkbox-group>
					</view>

					<!-- 字段数据 -->
					<!-- :style="{ width: isShowCheck ? '90%' : '100%' }" -->
					<view style="display: flex; flex-wrap: wrap; align-items: center; flex: 1">
						<view v-for="(fieldItem, fieIdIdx) in formFieldItem.fieldList" class="form-field" :class="isEntireRow || fieldItem.isEntireRow ? 'width-100' : 'width-50'">
							<!-- 自定义插槽 -->
							<slot v-if="fieldItem.scopedSlots && fieldItem.scopedSlots.customRender" :name="[fieldItem.scopedSlots.customRender]" :formFieldItem="formFieldItem" :fieldItem="fieldItem" :fieIdIdx="fieIdIdx" :formDataIdx="formDataIdx" :formDataItem="formDataItem"
								:titleMaxWidth="titleMaxWidth" />

							<template v-else>
								<view v-if="fieldItem.title" class="field-item-title">
									<view class="ellipsis-title" :style="{ width: titleMaxWidth }">{{ fieldItem.title }}</view>
									<span> : </span>
								</view>
								<view class="field-item-value" style="width: 100%">

									<!-- 文本框类型 -->
									<view v-if="fieldItem.type === 'input'">
										<u--input v-model="formDataItem[fieldItem.field]" class="inp" fontSize="24rpx" placeholder="请输入" border="surround" @change="(e) => changeForm(fieldItem, formDataItem, e)"></u--input>
									</view>
									<view v-else-if="fieldItem.type === 'image'"  @click.stop="preImage(fieldData(formDataItem[fieldItem.field]))">
										<view style="width: 80rpx;height: 80rpx;" v-if="fieldData(formDataItem[fieldItem.field])">
											<image :src="fieldData(formDataItem[fieldItem.field])" mode="" style="width: 100%;height: 100%;" ></image>
										</view>
										<text v-if="!fieldData(formDataItem[fieldItem.field])">暂无图片</text>
									</view>
									<!-- 日期选择类型 || 下拉选择器类型 -->
									<view v-else-if="fieldItem.type === 'date' || fieldItem.type === 'picker'" @click="changeForm(fieldItem, formDataItem)">
										<u-input v-model="formDataItem[fieldItem.field]" class="inp" fontSize="24rpx" placeholder="请选择" suffixIcon="arrow-down" suffixIconStyle="color: #909399"></u-input>
									</view>
									<span v-else style="font-size: 24rpx">{{fieldData(formDataItem[fieldItem.field])}}</span>
								</view>
							</template>
						</view>
					</view>
				</view>
			</view>
		</view>
		<!-- 日期选择器 -->
		<u-datetime-picker closeOnClickOverlay :show="dateShow" v-model="dateTimeValue" mode="date" @cancel="cancel('date')" @close="cancel('date')" @confirm="(e) => confirm(e, 'date')"></u-datetime-picker>
		<!-- 下拉框选择器 -->
		<u-picker closeOnClickOverlay :show="pickerShow" keyName="label" :columns="pickerList" @confirm="(e) => confirm(e, 'picker')" @cancel="cancel('picker')" @close="cancel('picker')"></u-picker>
	</view>
</template>
<script>
	import s from "@/config/sj.js";
	export default {
		name: "sListForm",
		props: {
			// 全局 - 是否占满整行
			isEntireRow: {
				type: Boolean,
				default: false,
			},
			// 是否展示勾选操作栏
			isShowCheck: {
				type: Boolean,
				default: false,
			},
			// 勾选栏类型 radio 单选 checkbox 多选
			checkType: {
				type: String,
				default: "radio",
			},
			// 表单展示数据
			formListData: {
				type: Array,
				default: () => [],
			},
			/** formFieldData 字段表数据源
			 * 单数据源示例：
			  {
			      headline: "物料信息", 
			      fieldList: [
			        {
			          title: "单价",
			          field: "price",
			          value: "priceValue",
			          type: "picker",
			          isEntireRow: true, // true 占满整行 false 一半行
			          list: [
			            {
			              value: "0",
			              label: "客供",
			            },
			            {
			              value: "1",
			              label: "大货",
			            },
			          ],
			          // 自定义插槽
			          scopedSlots: { customRender: "price" },
			        },
			      ],
			    },
			 * 字段数据
			 * 固定字段：headline fieldList title field value type list
			 * @param {String} headline 信息块标题【根据情况而定】
			 * @param {Array} fieldList 字段数据表【必需】
			 * @param {String} title 字段名称【必需】
			 * @param {String} field 字段【必需】
			 * @param {String} value 前端作展示字段用【根据情况而定】
			 * @param {String} type 类型字段 text 文本类型 picker 下拉框类型 date 时间类型 input 输入框类型【必需】
			 * @param {Boolean} isEntireRow 是否占满整行 true 占满 false 半行
			 * @param {Array} list 作为下拉框数据源【根据情况而定】
			 * @param {Object} scopedSlots 自定义插槽
			 */
			formFieldData: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				// 日期选择展示
				dateShow: false,
				// 下拉框选择展示
				pickerShow: false,
				// 下拉框选择数据
				pickerList: [],
				// 日期选择数据
				dateTimeValue: Number(new Date()),
				// 字段名称最大宽度
				titleMaxWidth: "",
				// 操作字段数据源
				fieldItem: {},
				// 数据源
				formDataItem: {},
				// 选中的数据
				selectedRows: [],
				selectedRowKeys: [],
				// 单选值
				radioGroupValue: "",
				// 多选
				checkBoxGroupValue: [],
			};
		},
		mounted() {
			// 获取所有字段名称DOM节点
			const titleList = document.querySelectorAll(".ellipsis-title");
			// 在所有字段名称取出最长宽度
			let titleMaxWidth = Math.max(
				...Array.from(titleList).map((t) => t.clientWidth)
			);
			// 宽度转换
			titleMaxWidth =
				titleMaxWidth > 0 && titleMaxWidth != -Infinity ? titleMaxWidth : 100;
			this.titleMaxWidth =
				titleMaxWidth * 2 < 150 ? titleMaxWidth * 2 + "rpx" : "150rpx";
		},
		computed: {
			// 处理字段数据
			fieldData() {
				return (data) => {
					return data ?? "-";
				};
			},
		},
		methods: {
			/**
			 * 按钮操作
			 * @param {Object} formDataItem formListData 数据源
			 * @param {S}
			 */
			selectChange(formDataItem, value) {
				// 多选
				if (this.checkType === "checkbox") {
					// 判断是否已存在 存在删除对应数据 不存在添加
					let idx = this.selectedRowKeys.indexOf(formDataItem.id);
					if (idx == -1) {
						this.selectedRows.push(formDataItem);
						this.selectedRowKeys.push(formDataItem.id);
						this.checkBoxGroupValue.push(formDataItem.id);
					} else {
						this.selectedRows.splice(idx, 1);
						this.selectedRowKeys.splice(idx, 1);
						this.checkBoxGroupValue.splice(idx, 1);
					}
				} else {
					// 单选
					this.selectedRows = [formDataItem];
					this.selectedRowKeys = [formDataItem.id];
					this.radioGroupValue = formDataItem.id;
				}
				console.log(
					"formDataItem",
					formDataItem,
					"value",
					value,
					"selectedRowKeys",
					this.selectedRowKeys,
					"selectedRows",
					this.selectedRows,
					"checkBoxGroupValue",
					this.checkBoxGroupValue
				);
				this.$emit("select", this.selectedRowKeys, this.selectedRows);
			},
			/**
			 * 清空勾选
			 */
			clearSelect() {
				this.selectedRows = [];
				this.selectedRowKeys = [];
				this.radioGroupValue = "";
				this.checkBoxGroupValue = [];
				this.$emit("select", [], []);
			},
			/**
			 * 关闭事件
			 * @param {String} type 关闭组件的类型
			 */
			cancel(type) {
				this[type + "Show"] = false;
			},
			/**
			 * 选择事件
			 * @param {Object} fieldItem 当前操作的字段数据源
			 * @param {Object} formDataItem 数据源
			 * @param {String} e 输入框的值 其他类型无
			 */
			changeForm(fieldItem, formDataItem, e) {
				this.fieldItem = fieldItem;
				this.formDataItem = formDataItem;
				if (fieldItem.type === "input") {
					this.$set(formDataItem, [this.fieldItem.field], e);
					this.$emit("changeForm", e, this.fieldItem, this.formDataItem);
					return;
				}
				if (fieldItem.type === "picker") {
					this.pickerList = [].concat([fieldItem?.list || []]);
				}
				this[fieldItem.type + "Show"] = true;
			},
			/**
			 * 时间选择 | 下拉框 确定事件
			 * @param {Object} e 原始数据
			 * @param {String} type 下拉框 picker | 时间 date
			 */
			confirm(e, type) {
				const {
					value
				} = e;
				if (type === "picker") {
					// this.fieldItem.fun(value[0])
					this.$set(this.formDataItem, [this.fieldItem.field], value[0].label);
					this.$set(this.formDataItem, [this.fieldItem.value], value[0].value);
					this.$emit("changeForm", value[0], this.fieldItem, this.formDataItem);
				}
				if (type === "date") {
					const timeValue = s.formateDate(new Date(value), "Y-M-D h:min:s");
					// const timeValue =
					//   new Date(parseInt(value))
					//     .toLocaleString()
					//     .replace(/:\d{1,2}$/, "")
					//     .replaceAll("/", "-") + ":00";
					this.$set(this.formDataItem, [this.fieldItem.field], timeValue);
					this.$emit("changeForm", timeValue, this.fieldItem, this.formDataItem);
				}
				this.cancel(type);
			},
			/**
			 * 点击卡片事件
			 */
			clickChange(formDataItem) {
				this.$emit("click", formDataItem.id, formDataItem);
			},
			preImage(url) {
				console.log()
				uni.previewImage({
					urls: [url],
					longPressActions: {
						success: function(data) {
							console.log('选中了第' + (data.tapIndex + 1) + '个按钮,第' + (data.index + 1) + '张图片');
						},
						fail: function(err) {
							console.log(err.errMsg);
						}
					}
				});
			}
		},
	};
</script>
<style lang="less" scoped scoped>
	@import "./s-list-form.less";
</style>